import { PaletteDark as o, PaletteLight as r } from "./palette.js";
const l = "3.2rem", d = "4rem", m = "5.6rem", i = (e) => ({
  sizeSmall: {
    height: l,
    fontSize: e.componentS.fontSize,
    lineHeight: e.componentS.lineHeight,
    borderRadius: "0.4rem"
  },
  sizeLarge: {
    height: m,
    fontSize: e.componentM.fontSize,
    lineHeight: e.componentM.lineHeight,
    fontWeight: e.fontWeightBold,
    borderRadius: "0.8rem"
  }
}), t = (e) => ({
  height: d,
  minWidth: "6.4rem",
  width: "fit-content",
  fontSize: e.componentM.fontSize,
  lineHeight: e.componentM.lineHeight,
  fontWeight: e.fontWeightBold,
  whiteSpace: "nowrap",
  borderRadius: "0.6rem",
  // Default transition with 'color' added to match 'background-color'
  transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
}), b = () => ({
  containedPrimary: {
    color: r.common.white,
    backgroundColor: r.primary[500],
    "&:disabled": {
      color: r.grey[400],
      backgroundColor: r.grey[100]
    },
    "&:focus:not(:active)": {
      backgroundColor: r.primary[400]
    },
    "&:hover": {
      backgroundColor: r.primary[400]
    },
    "&:active": {
      backgroundColor: r.primary[700]
    }
  },
  containedSecondary: {
    color: r.common.white,
    backgroundColor: r.error[500],
    "&:disabled": {
      color: r.grey[400],
      backgroundColor: r.grey[100]
    },
    "&:focus:not(:active)": {
      backgroundColor: r.error[700]
    },
    "&:hover": {
      backgroundColor: r.error[700]
    },
    "&:active": {
      backgroundColor: r.error[800]
    }
  },
  outlinedPrimary: {
    color: r.primary[500],
    borderColor: r.primary[500],
    backgroundColor: r.common.white,
    "&:focus:not(:active)": {
      color: r.primary[400],
      borderColor: r.primary[400],
      backgroundColor: r.common.white
    },
    "&:hover": {
      color: r.primary[400],
      borderColor: r.primary[400],
      backgroundColor: r.common.white
    },
    "&:active": {
      color: r.primary[700],
      borderColor: r.primary[700],
      backgroundColor: r.common.white
    }
  },
  outlinedSecondary: {
    color: r.error[500],
    borderColor: r.error[500],
    backgroundColor: r.common.white,
    "&:hover": {
      color: r.error[400],
      borderColor: r.error[400],
      backgroundColor: r.common.white
    },
    "&:active": {
      color: r.error[700],
      borderColor: r.error[700],
      backgroundColor: r.common.white
    },
    "&:focus:not(:active)": {
      color: r.error[400],
      borderColor: r.error[400],
      backgroundColor: r.common.white
    }
  }
}), C = (e) => {
  const c = b(), n = i(e);
  return {
    root: {
      ...t(e),
      "&.Mui-disabled": {
        color: r.grey[400],
        borderColor: r.grey[100]
      }
    },
    // text buttons are styled like links
    text: {
      border: "none",
      color: r.primary[500],
      "&:hover": {
        background: "none",
        textDecoration: "underline"
      }
    },
    textPrimary: {
      color: r.primary[500],
      "&:focus:not(:active)": {
        backgroundColor: r.primary[20]
      },
      "&:hover": {
        backgroundColor: r.primary[20],
        textDecoration: "none"
      },
      "&:active": {
        backgroundColor: r.primary[100],
        color: r.primary[700]
      }
    },
    textSecondary: {
      color: r.error[500],
      "&:focus:not(:active)": {
        backgroundColor: r.error[20]
      },
      "&:hover": {
        backgroundColor: r.error[20],
        textDecoration: "none"
      },
      "&:active": {
        backgroundColor: r.error[100],
        color: r.error[700]
      }
    },
    ...n,
    ...c
  };
}, u = () => ({
  containedPrimary: {
    color: o.primary[400],
    backgroundColor: o.common.white,
    "&:disabled": {
      color: o.primary[800],
      backgroundColor: o.primary[700]
    },
    "&:focus:not(:active)": {
      backgroundColor: o.primary[100]
    },
    "&:hover": {
      backgroundColor: o.primary[100],
      color: o.primary[500]
    },
    "&:active": {
      backgroundColor: o.primary[200],
      color: o.primary[700]
    }
  },
  containedSecondary: {
    color: o.error[400],
    backgroundColor: o.common.white,
    "&:disabled": {
      color: o.error[800],
      backgroundColor: o.error[700]
    },
    "&:focus:not(:active)": {
      backgroundColor: o.error[100]
    },
    "&:hover": {
      backgroundColor: o.error[100],
      color: o.error[500]
    },
    "&:active": {
      backgroundColor: o.error[200],
      color: o.error[700]
    }
  },
  outlinedPrimary: {
    color: o.common.white,
    borderColor: o.common.white,
    backgroundColor: "none",
    "&:disabled": {
      color: o.primary[700],
      borderColor: o.primary[700],
      backgroundColor: "none"
    },
    "&:focus:not(:active)": {
      color: o.primary[200],
      borderColor: o.primary[200],
      backgroundColor: "none"
    },
    "&:hover": {
      color: o.primary[200],
      borderColor: o.primary[200],
      background: "none",
      backgroundColor: "none"
    },
    "&:active": {
      color: o.primary[300],
      borderColor: o.primary[300],
      backgroundColor: "none"
    }
  },
  outlinedSecondary: {
    color: o.common.white,
    borderColor: o.common.white,
    backgroundColor: "none",
    "&:disabled": {
      color: o.error[700],
      borderColor: o.error[700],
      backgroundColor: "none"
    },
    "&:focus:not(:active)": {
      color: o.error[200],
      borderColor: o.error[200],
      backgroundColor: "none"
    },
    "&:hover": {
      color: o.error[200],
      borderColor: o.error[200],
      background: "none",
      backgroundColor: "none"
    },
    "&:active": {
      color: o.error[300],
      borderColor: o.error[300],
      backgroundColor: "none"
    }
  }
}), s = (e) => {
  const c = u(), n = i(e);
  return {
    root: {
      ...t(e),
      "&.Mui-disabled": {
        color: o.primary[400],
        borderColor: o.primary[400]
      }
    },
    // text buttons are styled like links
    text: {
      border: "none",
      color: o.primary[400],
      "&:hover": {
        background: "none",
        textDecoration: "underline"
      }
    },
    textPrimary: {
      color: o.primary[400],
      "&:disabled": {
        color: o.primary[700]
      },
      "&:focus:not(:active)": {
        color: o.primary[200],
        backgroundColor: o.primary[600]
      },
      "&:hover": {
        color: o.primary[200],
        backgroundColor: o.primary[600],
        textDecoration: "none"
      },
      "&:active": {
        backgroundColor: o.primary[500],
        color: o.common.white
      }
    },
    textSecondary: {
      color: o.error[400],
      "&:disabled": {
        color: o.error[700]
      },
      "&:focus:not(:active)": {
        color: o.error[200],
        backgroundColor: o.error[600]
      },
      "&:hover": {
        color: o.error[200],
        backgroundColor: o.error[600],
        textDecoration: "none"
      },
      "&:active": {
        backgroundColor: o.error[500],
        color: o.common.white
      }
    },
    ...n,
    ...c
  };
}, k = {
  root: {
    color: o.common.white,
    "&.Mui-disabled": {
      color: o.primary[700]
    }
  },
  colorPrimary: {
    color: o.common.white
  },
  colorSecondary: {
    color: o.common.white
  }
};
export {
  s as MuiButtonOverridesDark,
  C as MuiButtonOverridesLight,
  k as MuiIconButtonOverridesDark,
  u as getButtonOverridesDark,
  b as getButtonOverridesLight
};
//# sourceMappingURL=buttons.js.map
